export class PasswordUtil {
  old: string = "";
  password: string = "";
  confirmation: string = "";

  valid: boolean = false;
}
